export class Union {
  id!: number;
  union_name!: string;
  upozilla_name!: string;
  zilla_name!: string;
  ek_chala!: number;
  dui_chala!: number;
  char_chala!: number;
  adha_paka!: number;
  paka!: number;
  ek_tola!: number;
  dui_tola!: number;
  tin_tola!: number;
  char_tola!: number;
  bohutol!: number;
  ek_chala_kor!: number;
  dui_chala_kor!: number;
  char_chala_kor!: number;
  adha_paka_kor!: number;
  paka_kor!: number;
  ek_tola_kor!: number;
  dui_tola_kor!: number;
  tin_tola_kor!: number;
  char_tola_kor!: number;
  bohutol_kor!: number;
  is_create_assessment_msg_on!: boolean;
  is_tax_collection_msg_on!: boolean;
  create_assessment_msg!: string;
  tax_collection_msg!: string;
  current_financial_year!: number;
}
